var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.chips.length
    ? _c(_setup.SliderGroup, {
        class: _setup.isMobile ? "mx-n2" : undefined,
        attrs: {
          items: _setup.chips,
          fog: !_setup.isMobile,
          "padding-x": _setup.isMobile ? 8 : undefined,
          "no-auto-position": "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ item, onClick }) {
                return [
                  item.menuChip
                    ? _c(_setup.MenuChip, {
                        attrs: { item: item, "on-click": onClick },
                      })
                    : item.mapChip
                    ? _c(_setup.MapChip)
                    : _c(_setup.DefaultChip, {
                        attrs: { item: item, "on-click": onClick },
                      }),
                ]
              },
            },
          ],
          null,
          false,
          1911868678
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }